import { render } from "./mister.vue?vue&type=template&id=73474eb8"
import script from "./mister.vue?vue&type=script&lang=js"
export * from "./mister.vue?vue&type=script&lang=js"

import exportComponent from "/srv/sites/eservice.talronbatt.co.il/api/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__